/**
 * All feature flags in this array will be fetched from launch darkly (via the candidate graph)
 * as chalice server-side renders
 */
export const REFINE_BAR_V2_FEATURE_FLAG =
  'experiment-dynamic-pills-v2-sticky-search-bar';

export const featureFlagsToFetch = [];
